"use client";

import type { ReactNode } from "react";
import { useCardsOpen } from "@/lib/useCardsOpen";

/** Renders its children only while cards can still be ordered for Christmas (lib/cards cardsOpen). */
export function CardsOpenGate({ children }: { children: ReactNode }) {
  return useCardsOpen() ? <>{children}</> : null;
}
